var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (id, menus) {
      pug_mixins["icon"] = pug_interp = function(iconId, extraClassnames=''){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Csvg" + (pug.attr("class", pug.classes(["icon",(extraClassnames !== '') ? extraClassnames : false], [false,true]), false, true)+" aria-hidden=\"true\"") + "\u003E\u003Cuse" + (pug.attr("xlink:href", `#${iconId}`, true, true)) + "\u002F\u003E\u003C\u002Fsvg\u003E";
};
pug_html = pug_html + "\u003Cdiv" + (" class=\"offcanvas offcanvas-mobile-menu offcanvas-start\""+pug.attr("id", id, true, true)) + "\u003E\u003Cdiv class=\"offcanvas-body d-flex flex-column justify-content-start align-items-stretch overflow-x-hidden overflow-y-auto scrollbar\"\u003E\u003Cdiv class=\"flex-grow-1 flex-shrink-0 d-flex flex-column justify-content-stretch align-items-stretch\"\u003E\u003Cdiv class=\"swiper w-100 min-h-100\" data-slider=\"menu_mobile\"\u003E\u003Cdiv class=\"swiper-wrapper min-h-100\"\u003E";
// iterate menus.main
;(function(){
  var $$obj = menus.main;
  if ('number' == typeof $$obj.length) {
      for (var slideIndex = 0, $$l = $$obj.length; slideIndex < $$l; slideIndex++) {
        var slide = $$obj[slideIndex];
pug_html = pug_html + "\u003Cdiv class=\"swiper-slide min-h-100\"\u003E";
// iterate slide
;(function(){
  var $$obj = slide;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var menu = $$obj[pug_index1];
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["menu-mobile",`menu-mobile-${menu.menuType}`,(menu.menuType === 'alternate') ? 'border-top border-dark' : false], [false,true,true]), false, true)) + "\u003E\u003Cul" + (pug.attr("class", pug.classes(["nav","flex-column",(slideIndex > 0) ? 'd-none' : false], [false,false,true]), false, true)+pug.attr("data-menu", menu.zoneId, true, true)) + "\u003E";
if (menu.backLabel) {
pug_html = pug_html + "\u003Cli class=\"nav-item pb-2\"\u003E\u003Ca class=\"nav-link back border-bottom\" href=\"#\" data-menu-back\u003E";
pug_mixins["icon"]('icon-arrow-left');
pug_html = pug_html + (pug.escape(null == (pug_interp = menu.backLabel) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
}
// iterate menu.items
;(function(){
  var $$obj = menu.items;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var item = $$obj[pug_index2];
pug_html = pug_html + "\u003Cli class=\"nav-item\"\u003E";
if (item.isLink) {
pug_html = pug_html + ("\u003Ca" + (pug.attr("class", pug.classes([item.classname.join(' ')], [true]), false, true)+pug.attr("href", item.href, true, true)+pug.attr("target", item.target, true, true)+pug.attr("data-level", (item.targetZoneId) ? `${slideIndex + 1}` : false, true, true)+pug.attr("data-menu", (item.targetZoneId) ? item.targetZoneId : false, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = item.label) ? "" : pug_interp)));
if (item.targetZoneId) {
pug_mixins["icon"]('icon-arrow-right');
}
pug_html = pug_html + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"nav-link font-secondary text-uppercase text-primary lh-1 fw-semibold fs-strong letter-space-auto\"\u003E" + (pug.escape(null == (pug_interp = item.label) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var item = $$obj[pug_index2];
pug_html = pug_html + "\u003Cli class=\"nav-item\"\u003E";
if (item.isLink) {
pug_html = pug_html + ("\u003Ca" + (pug.attr("class", pug.classes([item.classname.join(' ')], [true]), false, true)+pug.attr("href", item.href, true, true)+pug.attr("target", item.target, true, true)+pug.attr("data-level", (item.targetZoneId) ? `${slideIndex + 1}` : false, true, true)+pug.attr("data-menu", (item.targetZoneId) ? item.targetZoneId : false, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = item.label) ? "" : pug_interp)));
if (item.targetZoneId) {
pug_mixins["icon"]('icon-arrow-right');
}
pug_html = pug_html + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"nav-link font-secondary text-uppercase text-primary lh-1 fw-semibold fs-strong letter-space-auto\"\u003E" + (pug.escape(null == (pug_interp = item.label) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var menu = $$obj[pug_index1];
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["menu-mobile",`menu-mobile-${menu.menuType}`,(menu.menuType === 'alternate') ? 'border-top border-dark' : false], [false,true,true]), false, true)) + "\u003E\u003Cul" + (pug.attr("class", pug.classes(["nav","flex-column",(slideIndex > 0) ? 'd-none' : false], [false,false,true]), false, true)+pug.attr("data-menu", menu.zoneId, true, true)) + "\u003E";
if (menu.backLabel) {
pug_html = pug_html + "\u003Cli class=\"nav-item pb-2\"\u003E\u003Ca class=\"nav-link back border-bottom\" href=\"#\" data-menu-back\u003E";
pug_mixins["icon"]('icon-arrow-left');
pug_html = pug_html + (pug.escape(null == (pug_interp = menu.backLabel) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
}
// iterate menu.items
;(function(){
  var $$obj = menu.items;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var item = $$obj[pug_index3];
pug_html = pug_html + "\u003Cli class=\"nav-item\"\u003E";
if (item.isLink) {
pug_html = pug_html + ("\u003Ca" + (pug.attr("class", pug.classes([item.classname.join(' ')], [true]), false, true)+pug.attr("href", item.href, true, true)+pug.attr("target", item.target, true, true)+pug.attr("data-level", (item.targetZoneId) ? `${slideIndex + 1}` : false, true, true)+pug.attr("data-menu", (item.targetZoneId) ? item.targetZoneId : false, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = item.label) ? "" : pug_interp)));
if (item.targetZoneId) {
pug_mixins["icon"]('icon-arrow-right');
}
pug_html = pug_html + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"nav-link font-secondary text-uppercase text-primary lh-1 fw-semibold fs-strong letter-space-auto\"\u003E" + (pug.escape(null == (pug_interp = item.label) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var item = $$obj[pug_index3];
pug_html = pug_html + "\u003Cli class=\"nav-item\"\u003E";
if (item.isLink) {
pug_html = pug_html + ("\u003Ca" + (pug.attr("class", pug.classes([item.classname.join(' ')], [true]), false, true)+pug.attr("href", item.href, true, true)+pug.attr("target", item.target, true, true)+pug.attr("data-level", (item.targetZoneId) ? `${slideIndex + 1}` : false, true, true)+pug.attr("data-menu", (item.targetZoneId) ? item.targetZoneId : false, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = item.label) ? "" : pug_interp)));
if (item.targetZoneId) {
pug_mixins["icon"]('icon-arrow-right');
}
pug_html = pug_html + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"nav-link font-secondary text-uppercase text-primary lh-1 fw-semibold fs-strong letter-space-auto\"\u003E" + (pug.escape(null == (pug_interp = item.label) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var slideIndex in $$obj) {
      $$l++;
      var slide = $$obj[slideIndex];
pug_html = pug_html + "\u003Cdiv class=\"swiper-slide min-h-100\"\u003E";
// iterate slide
;(function(){
  var $$obj = slide;
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var menu = $$obj[pug_index4];
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["menu-mobile",`menu-mobile-${menu.menuType}`,(menu.menuType === 'alternate') ? 'border-top border-dark' : false], [false,true,true]), false, true)) + "\u003E\u003Cul" + (pug.attr("class", pug.classes(["nav","flex-column",(slideIndex > 0) ? 'd-none' : false], [false,false,true]), false, true)+pug.attr("data-menu", menu.zoneId, true, true)) + "\u003E";
if (menu.backLabel) {
pug_html = pug_html + "\u003Cli class=\"nav-item pb-2\"\u003E\u003Ca class=\"nav-link back border-bottom\" href=\"#\" data-menu-back\u003E";
pug_mixins["icon"]('icon-arrow-left');
pug_html = pug_html + (pug.escape(null == (pug_interp = menu.backLabel) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
}
// iterate menu.items
;(function(){
  var $$obj = menu.items;
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var item = $$obj[pug_index5];
pug_html = pug_html + "\u003Cli class=\"nav-item\"\u003E";
if (item.isLink) {
pug_html = pug_html + ("\u003Ca" + (pug.attr("class", pug.classes([item.classname.join(' ')], [true]), false, true)+pug.attr("href", item.href, true, true)+pug.attr("target", item.target, true, true)+pug.attr("data-level", (item.targetZoneId) ? `${slideIndex + 1}` : false, true, true)+pug.attr("data-menu", (item.targetZoneId) ? item.targetZoneId : false, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = item.label) ? "" : pug_interp)));
if (item.targetZoneId) {
pug_mixins["icon"]('icon-arrow-right');
}
pug_html = pug_html + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"nav-link font-secondary text-uppercase text-primary lh-1 fw-semibold fs-strong letter-space-auto\"\u003E" + (pug.escape(null == (pug_interp = item.label) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var item = $$obj[pug_index5];
pug_html = pug_html + "\u003Cli class=\"nav-item\"\u003E";
if (item.isLink) {
pug_html = pug_html + ("\u003Ca" + (pug.attr("class", pug.classes([item.classname.join(' ')], [true]), false, true)+pug.attr("href", item.href, true, true)+pug.attr("target", item.target, true, true)+pug.attr("data-level", (item.targetZoneId) ? `${slideIndex + 1}` : false, true, true)+pug.attr("data-menu", (item.targetZoneId) ? item.targetZoneId : false, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = item.label) ? "" : pug_interp)));
if (item.targetZoneId) {
pug_mixins["icon"]('icon-arrow-right');
}
pug_html = pug_html + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"nav-link font-secondary text-uppercase text-primary lh-1 fw-semibold fs-strong letter-space-auto\"\u003E" + (pug.escape(null == (pug_interp = item.label) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var menu = $$obj[pug_index4];
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["menu-mobile",`menu-mobile-${menu.menuType}`,(menu.menuType === 'alternate') ? 'border-top border-dark' : false], [false,true,true]), false, true)) + "\u003E\u003Cul" + (pug.attr("class", pug.classes(["nav","flex-column",(slideIndex > 0) ? 'd-none' : false], [false,false,true]), false, true)+pug.attr("data-menu", menu.zoneId, true, true)) + "\u003E";
if (menu.backLabel) {
pug_html = pug_html + "\u003Cli class=\"nav-item pb-2\"\u003E\u003Ca class=\"nav-link back border-bottom\" href=\"#\" data-menu-back\u003E";
pug_mixins["icon"]('icon-arrow-left');
pug_html = pug_html + (pug.escape(null == (pug_interp = menu.backLabel) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
}
// iterate menu.items
;(function(){
  var $$obj = menu.items;
  if ('number' == typeof $$obj.length) {
      for (var pug_index6 = 0, $$l = $$obj.length; pug_index6 < $$l; pug_index6++) {
        var item = $$obj[pug_index6];
pug_html = pug_html + "\u003Cli class=\"nav-item\"\u003E";
if (item.isLink) {
pug_html = pug_html + ("\u003Ca" + (pug.attr("class", pug.classes([item.classname.join(' ')], [true]), false, true)+pug.attr("href", item.href, true, true)+pug.attr("target", item.target, true, true)+pug.attr("data-level", (item.targetZoneId) ? `${slideIndex + 1}` : false, true, true)+pug.attr("data-menu", (item.targetZoneId) ? item.targetZoneId : false, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = item.label) ? "" : pug_interp)));
if (item.targetZoneId) {
pug_mixins["icon"]('icon-arrow-right');
}
pug_html = pug_html + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"nav-link font-secondary text-uppercase text-primary lh-1 fw-semibold fs-strong letter-space-auto\"\u003E" + (pug.escape(null == (pug_interp = item.label) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index6 in $$obj) {
      $$l++;
      var item = $$obj[pug_index6];
pug_html = pug_html + "\u003Cli class=\"nav-item\"\u003E";
if (item.isLink) {
pug_html = pug_html + ("\u003Ca" + (pug.attr("class", pug.classes([item.classname.join(' ')], [true]), false, true)+pug.attr("href", item.href, true, true)+pug.attr("target", item.target, true, true)+pug.attr("data-level", (item.targetZoneId) ? `${slideIndex + 1}` : false, true, true)+pug.attr("data-menu", (item.targetZoneId) ? item.targetZoneId : false, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = item.label) ? "" : pug_interp)));
if (item.targetZoneId) {
pug_mixins["icon"]('icon-arrow-right');
}
pug_html = pug_html + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"nav-link font-secondary text-uppercase text-primary lh-1 fw-semibold fs-strong letter-space-auto\"\u003E" + (pug.escape(null == (pug_interp = item.label) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
if (menus.lang && menus.lang.length > 0) {
pug_html = pug_html + "\u003Cdiv class=\"flex-grow-0 flex-shrink-0 h-72px d-flex justify-content-stretch align-items-stretch bg-texture-dark\"\u003E\u003Cul class=\"nav nav-lang align-items-stretch justify-content-between w-100\"\u003E";
// iterate menus.lang
;(function(){
  var $$obj = menus.lang;
  if ('number' == typeof $$obj.length) {
      for (var pug_index7 = 0, $$l = $$obj.length; pug_index7 < $$l; pug_index7++) {
        var item = $$obj[pug_index7];
pug_html = pug_html + ("\u003Cli class=\"nav-item flex-grow-1 d-flex flex-column justify-content-center align-items-center\"\u003E\u003Ca" + (pug.attr("class", pug.classes(["nav-link","fs-strong",(item.isActive) ? 'active' : false,(item.isExternal) ? 'external' : false], [false,false,true,true]), false, true)+pug.attr("href", item.href, true, true)+pug.attr("aria-label", (item.aria_label) ? item.aria_label : false, true, true)+pug.attr("target", item.target, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = item.label) ? "" : pug_interp)));
if (item.isExternal) {
pug_mixins["icon"]('icon-link');
}
pug_html = pug_html + "\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index7 in $$obj) {
      $$l++;
      var item = $$obj[pug_index7];
pug_html = pug_html + ("\u003Cli class=\"nav-item flex-grow-1 d-flex flex-column justify-content-center align-items-center\"\u003E\u003Ca" + (pug.attr("class", pug.classes(["nav-link","fs-strong",(item.isActive) ? 'active' : false,(item.isExternal) ? 'external' : false], [false,false,true,true]), false, true)+pug.attr("href", item.href, true, true)+pug.attr("aria-label", (item.aria_label) ? item.aria_label : false, true, true)+pug.attr("target", item.target, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = item.label) ? "" : pug_interp)));
if (item.isExternal) {
pug_mixins["icon"]('icon-link');
}
pug_html = pug_html + "\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "menus" in locals_for_with ?
        locals_for_with.menus :
        typeof menus !== 'undefined' ? menus : undefined));
    ;;return pug_html;}

module.exports = template